module.exports = __webpack_public_path__ + "img/A1_HQ03.f13528f3.jpg";